export default "__VITE_ASSET__444ad489__"